import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { VendorService } from '@app/core/services';
import { TimeSlotInventoryDataModel } from 'src/@allxs/model/inventory/timeslotinventorydata.model';
import { GetProductInventoryAction, HoldInventoryAction, ReleaseInventoryAction, ClearProductError, ReleaseInventoryBasicAction } from '../actions/product.actions';
import { tap } from 'rxjs';
import { DialogService } from '@app/core/services/dialog.service';


export class ProductStateModel {
  public selectedProductInventory: TimeSlotInventoryDataModel;
  public selectedProduct: string;
  public error: any;
}

@State<ProductStateModel>({
  name: 'product',
  defaults: {
    selectedProductInventory: null,
    selectedProduct: null,
    error: null
  }
})

@Injectable()
export class ProductState {

  constructor(private _vendorService: VendorService,
    private _router: Router,
    private store: Store,
    private dialogService: DialogService) {
  }

  @Selector()
  public static selectedProductInventory(state: ProductStateModel) {
    return state.selectedProductInventory;
  }

  @Selector()
  public static error(state: ProductStateModel) {
    return state.error;
  }
  
  @Selector()
  public static selectedProduct(state: ProductStateModel) {
    return state.selectedProduct;
  }

  @Action(GetProductInventoryAction)
  public selectVendorAction(ctx: StateContext<ProductStateModel>, action: GetProductInventoryAction) {
    this._vendorService.getProductinventory(action.productId).subscribe(data => {
      ctx.patchState({ selectedProductInventory: data });
    })
  }

  @Action(HoldInventoryAction)
  public holdInventoryAction(ctx: StateContext<ProductStateModel>, action: HoldInventoryAction) {
    return this._vendorService.holdTimeSlotInventory(action.productId, action.timeSlot).pipe(
      tap(data => {
        var state = ctx.getState();
        //var selectedProduct = state.selectedProductInventory.dateSlots[action.timeSlot.dateSlotId].timeSlots[action.timeSlot.id].inventory[action.timeSlot.inventory]
        ctx.patchState({ 
          selectedProductInventory: data,
          selectedProduct: data.updatesInventoryId
        });
      }, error => {
        ctx.patchState({ 
          selectedProductInventory: null,
          error: error
        });
      })
    ) 
  }


  @Action(ReleaseInventoryAction)
  public reeleaseInventoryAction(ctx: StateContext<ProductStateModel>, action: ReleaseInventoryAction) {

    this._vendorService.releaseTimeSlotInventory(action.productId, action.inventoryId, action.timeSlot).subscribe(data => {
      ctx.patchState({ 
        selectedProductInventory: data,
        selectedProduct: null
      });
    })
  }

  @Action(ReleaseInventoryBasicAction)
  public releaseInventoryBasicAction(ctx: StateContext<ProductStateModel>, action: ReleaseInventoryBasicAction) {
    this._vendorService.releaseTimeSlotInventoryBasic(action.inventoryId, action.productId).subscribe(data => {
      ctx.patchState({ 
        selectedProductInventory: data,
        selectedProduct: null
      });
    })
  }   

  @Action(ClearProductError)
  public clearProductErrorAction(ctx: StateContext<ProductStateModel>) {
    ctx.patchState({ error: null });
  } 

} 
